import { useChatContext } from '@/contexts/chat/context';
import ChatMain from '../chat-main';
import classes from './index.module.scss';

const Chat = () => {
  const { chatsState, chatMediaCall, mediaJoin, chatGroup } = useChatContext();
  if (chatsState.activatedChats?.length === 0) {
    return (
      <div className={classes.tips}>
        <div className={classes.tip}>Select a chat to start messaging</div>
      </div>
    );
  }
  return chatsState.activatedChats?.map((item) => {
    return (
      <div
        className={classes.chat_container}
        key={item.chat_id}
        hidden={chatsState.activatedChat?.chat_id !== item.chat_id}
      >
        <ChatMain
          chat={item}
          chatGroup={chatGroup}
          chatMediaCall={chatMediaCall}
          mediaJoin={mediaJoin}
        ></ChatMain>
      </div>
    );
  });
};

export default Chat;
